import type { IBeneficiaryProjectRepository } from "@/application/ports/repositories";
import type { ApiResponse } from "@/application/ports/types";
import type { ProjectBulkCreateRequest, ProjectBulkCreateResponse } from "@/domain";
import * as sdk from "../generated/sdk.gen";
import { unwrap } from "../unwrap";

export class BeneficiaryProjectRepository implements IBeneficiaryProjectRepository {
  async bulkCreateBeneficiaryProjects(
    beneficiaryUuid: string,
    payload: ProjectBulkCreateRequest,
  ): Promise<ApiResponse<ProjectBulkCreateResponse>> {
    const data = await unwrap(
      sdk.createProjectsBulkForBeneficiary({
        path: { beneficiary_uuid: beneficiaryUuid },
        body: payload,
      }),
    );
    return { data, status: 200, success: true };
  }
}
